"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgApplication = function SvgApplication(_ref) {
  var fill = _ref.fill,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M17 12V10H7V12H17Z",
      fill: fill
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M7 16V14H17V16H7Z",
      fill: fill
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99963 3H4C3.73478 3 3.48042 3.10536 3.29288 3.29291C3.10534 3.48045 2.99999 3.73481 3 4.00003V20C3 20.2652 3.10535 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H20C20.5523 21 21 20.5521 21 19.9998V4C21 3.44772 20.5523 3 20 3H16.0004C15.0882 1.78555 13.6358 1 12 1C10.3642 1 8.91184 1.78555 7.99963 3ZM12 3C13.3062 3 14.4175 3.83481 14.8293 5H9.17071C9.58254 3.83481 10.6938 3 12 3ZM7.10002 5C7.03443 5.32311 7 5.65753 7 6C7 6.55228 7.44772 7 8 7H16C16.5523 7 17 6.55228 17 6C17 5.65753 16.9656 5.32311 16.9 5H19V19H5.00001L5 5H7.10002ZM20 20C21 20 21 19.9998 21 19.9998L20 20Z",
      fill: fill
    })]
  }));
};

var _default = SvgApplication;
exports["default"] = _default;